@if (!!href()) {
    <a
        target="_blank"
        rel="noopener noreferrer"
        [attr.href]="href()"
        [class]="class()"
        [ngClass]="buttonClassList()"
        [attr.data-id]="id()"
        [attr.aria-label]="tooltip() | translate"
        (click)="$event.stopPropagation()"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </a>
} @else if (!!routerTo()) {
    <a
        [routerLink]="routerTo()"
        [queryParams]="queryParams()"
        [class]="class()"
        [ngClass]="buttonClassList()"
        [attr.data-id]="id()"
        [attr.aria-label]="tooltip() | translate"
        (click)="handleClick($event)"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </a>
} @else {
    <button
        [class]="class()"
        [ngClass]="buttonClassList()"
        [disabled]="disabled() || loading()"
        [attr.data-id]="id()"
        [attr.aria-label]="tooltip() | translate"
        (click)="handleClick($event)"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
}

<ng-template #buttonTemplate>
    @if (!loading()) {
        <stby-icon
            [size]="iconSizeMapped()"
            [icon]="icon()"
            [rotate]="rotate()"
            [fill]="iconFillColor()"
            [alt]="tooltip()"
            [matTooltip]="tooltip() | translate"
            [matTooltipPosition]="tooltipPosition()"
        />
    }

    @if (loading()) {
        <stby-loader-dots />
    }
</ng-template>
